// src/colors.js
// Central place for color variables

const COLORS = {
  orange: "#e97522",
  darkGray: "#4e4e4e",
};

export default COLORS;
